<template>
  <div class="bg-white">
    <loading :active.sync="isLoading" :is-full-page="fullPageLoader" :color="loaderColor"></loading>
    <gd-tabs :tabs="generalTabs" :current-tab="generalTab" :wrapper-class="'pt-4 px-8 gs-default-tabs'"
      :tab-class="'pb-1 mr-4 gs-default-tabs-item'" :tab-active-class="'border-primary border-b-2 text-primary gs-default-tabs-item-active'
        " :line-class="'gs-default-tabs-active-line'" @onClick="generalTabChange" />
    <div v-if="generalTab === 'seo_setting'" class="flex flex-col w-full px-8 py-5">
      <!-- <i class="fas fa-upload"></i> -->
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_post_url') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input class="" v-model="setUrl.seo_blogpost" placeholder="" :validator="$v.setUrl.seo_blogpost"
              ref="postarea" />
          </div>
          <div v-if="postnameToken">/{slug}</div>
        </div>
        <div class="flex flex-col mt-2">
          <label class="text-grey-dark text-sm mb-2">{{ $t('frontend_grooveblog_available_tag') }}:</label>
          <div class="flex">
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_blogpost.search('monthnum') > -1 ? 'active' : '',
            ]" @click="postTokenEnter('%monthnum%/')">%monthnum%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3"
              :class="[setUrl.seo_blogpost.search('day') > -1 ? 'active' : '']"
              @click="postTokenEnter('%day%/')">%day%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_blogpost.search('category') > -1 ? 'active' : '',
            ]" @click="postTokenEnter('%category%/')">%category%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_blogpost.search('hour') > -1 ? 'active' : '',
            ]" @click="postTokenEnter('%hour%/')">%hour%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_blogpost.search('minute') > -1 ? 'active' : '',
            ]" @click="postTokenEnter('%minute%/')">%minute%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_blogpost.search('second') > -1 ? 'active' : '',
            ]" @click="postTokenEnter('%second%/')">%second%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_blogpost.search('postname') > -1 ? 'active' : '',
            ]" @click="postTokenEnter('%postname%/')">%postname%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_blogpost.search('slug') > -1 ? 'active' : '',
            ]" @click="postTokenEnter('%slug%/')">%slug%</gd-button>
          </div>
          <div v-if="tagError" class="w-full error text-primary-dark mt-2 text-sm">
            {{ $t('frontend_grooveblog_have_multiple_cat') }}
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">Tag URL</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input v-model="setUrl.seo_tag" class="w-2/3 " placeholder="" :validator="$v.setUrl.seo_tag"
              ref="tagarea" />
          </div>
          <div>/{slug}</div>
        </div>
        <div class="flex flex-col mt-2">
          <label class="text-grey-dark text-sm mb-2">{{ $t('frontend_grooveblog_available_tag') }}:</label>
          <div class="flex">
            <gd-button size="auto" class="px-4 available-tags mr-3" ref="myarea" :class="[
              setUrl.seo_tag.search('monthnum') > -1 ? 'active' : '',
            ]" @click="tagTokenEnter('%monthnum%/')">%monthnum%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3"
              :class="[setUrl.seo_tag.search('day') > -1 ? 'active' : '']"
              @click="tagTokenEnter('%day%/')">%day%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_tag.search('year') > -1 ? 'active' : '',
            ]" @click="tagTokenEnter('%year%/')">%year%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_tag.search('hour') > -1 ? 'active' : '',
            ]" @click="tagTokenEnter('%hour%/')">%hour%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_tag.search('minute') > -1 ? 'active' : '',
            ]" @click="tagTokenEnter('%minute%/')">%minute%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_tag.search('second') > -1 ? 'active' : '',
            ]" @click="tagTokenEnter('%second%/')">%second%</gd-button>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_categories_url') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input class="" v-model="setUrl.seo_categories" placeholder="" :validator="$v.setUrl.seo_categories"
              ref="categoryarea" />
          </div>
          <div>/{slug}</div>
        </div>
        <div class="flex flex-col mt-2">
          <label class="text-grey-dark text-sm mb-2">{{ $t('frontend_grooveblog_available_tag') }}:</label>
          <div class="flex">
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_categories.search('monthnum') > -1 ? 'active' : '',
            ]" @click="categoryTokenEnter('%monthnum%/')">%monthnum%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3"
              :class="[setUrl.seo_categories.search('day') > -1 ? 'active' : '']"
              @click="categoryTokenEnter('%day%/')">%day%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_categories.search('year') > -1 ? 'active' : '',
            ]" @click="categoryTokenEnter('%year%/')">%year%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_categories.search('hour') > -1 ? 'active' : '',
            ]" @click="categoryTokenEnter('%hour%/')">%hour%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_categories.search('minute') > -1 ? 'active' : '',
            ]" @click="categoryTokenEnter('%minute%/')">%minute%</gd-button>
            <gd-button size="auto" class="px-4 available-tags mr-3" :class="[
              setUrl.seo_categories.search('second') > -1 ? 'active' : '',
            ]" @click="categoryTokenEnter('%second%/')">%second%</gd-button>
          </div>
        </div>
      </div>

      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_preferred_url') }}</label>
        <label class="text-grey-dark text-sm mb-2">{{ $t('frontend_preferred_url_description') }}</label>
        <div class="w-full flex">
          <div class="domain-radio domain-radio-small" v-for="option in preferredRootDomainUrlOptions" :key="option.id">
            <gd-custom-radio v-model="setUrl.preferred_url" :option="option" @onUpdateOption="preferredRootDomainUrlChange"></gd-custom-radio>
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveUrl">{{ $t('frontend_save') }}</gd-button>
      </div>
    </div>
    <div v-if="generalTab === 'domain_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="domain-radio flex flex-col mb-1">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_publish_to') }}</label>
        <div v-for="domainOption in domainType" :key="domainOption.id">
          <gd-custom-radio v-model="domainTypeValue" :option="domainOption"
            @onUpdateOption="domainTypeChange"></gd-custom-radio>
        </div>
      </div>
      <div class="flex flex-col mb-5" v-if="domainTypeValue === 1">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_change_subdomain') }}</label>
        <div class="w-80">
          <text-input class="" v-model="setBlogSite.sub_domain" value="setBlogSite.sub_domain" placeholder=""
            :validator="$v.setBlogSite.sub_domain" @input="touchInput" />
        </div>
        <div class="text-grey-500 mt-1">
          https://{{ setBlogSite.sub_domain }}.{{ grooveblogDomain }}
        </div>
        <div class="w-full error text-primary-dark mt-1 text-sm" v-if="subDomainMessage">
          {{ $t('frontend_grooveblog_subdomain_unavailable') }}
        </div>
      </div>
      <div class="mb-5" v-else>
        <div class="flex items-end">
          <div class="w-80">
            <div v-if="domainTypeValue === 2">
              <domain-dropdown class="w-full selectbox form-selectbox select-domain" v-model="setBlogSite.custom_domains"
                type="blog" />
            </div>
            <div v-else>
              <domain-dropdown class="w-full selectbox form-selectbox select-domain" v-model="setBlogSite.custom_domains"
                type="pages" />
            </div>
          </div>
          <gd-button size="large" variant="outline" class="ml-5 h-10" @click="editDomains">{{
            $t('frontend_grooveblog_edit_domains') }}</gd-button>
        </div>

        <div class="text-grey-500 mt-1" v-if="!setBlogSite.publish_folder">
          https://{{ setBlogSite.custom_domains }}
        </div>
        <div class="w-full error text-primary-dark mt-1 text-sm" v-if="customDomainMessage">
          {{ $t('frontend_grooveblog_domain_unavailable') }}
        </div>
      </div>
      <div class="flex flex-col mb-5" v-if="domainTypeValue === 3 && setBlogSite.custom_domains">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_folder_name') }}</label>
        <div class="w-80">
          <text-input class="" v-model="setBlogSite.folder_name" value="setBlogSite.folder_name" placeholder="" />
        </div>
        <div class="w-full error text-primary-dark mt-1 text-sm" v-if="!domainAvailable">
          {{ $t('frontend_grooveblog_no_page_publish_domain') }}
        </div>
        <div class="w-full error text-primary-dark mt-1 text-sm" v-if="domainAvailable && !folderAvailable">
          {{ $t('frontend_grooveblog_folder_unavailable') }}
        </div>
        <div class="text-grey-500 mt-1" v-if="setBlogSite.publish_folder">
          https://{{ setBlogSite.custom_domains }}/{{ setBlogSite.folder_name }}
        </div>
      </div>
      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveBlogSite">{{ $t('frontend_save')
        }}</gd-button>
      </div>
    </div>
    <div v-if="generalTab === 'logo_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-5">{{ $t('frontend_grooveblog_upload_logo') }}</label>
        <div class="w-80">
          <image-picker v-model="logoImage" :primary="true"></image-picker>
        </div>
        <div class="w-full mb-5">
          <strong class="w-full text-grey-800">
            {{ $t('frontend_grooveblog_recommended_format') }}:
          </strong>
          <span class="w-full text-grey-700">
            {{ $t('frontend_grooveblog_recommended_logo_format_desc') }}
          </span>
        </div>
        <div class="flex flex-row">
          <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveLogo">{{ $t('frontend_save')
          }}</gd-button>
        </div>
      </div>
    </div>
    <div v-if="generalTab === 'favicon_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-5">{{ $t('frontend_grooveblog_upload_favicon') }}</label>
        <div class="w-80">
          <image-picker v-model="faviconImage" :primary="true"></image-picker>
        </div>
        <div class="w-full mb-5">
          <strong class="w-full text-grey-800">{{ $t('frontend_grooveblog_recommended_format') }}:</strong>
          <span class="w-full text-grey-700">
            {{ $t('frontend_grooveblog_recommended_fav_format_desc') }}
          </span>
        </div>
        <div class="flex flex-row">
          <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveFavicon">{{ $t('frontend_save')
          }}</gd-button>
        </div>
      </div>
    </div>
    <div v-if="generalTab === 'social_setting'" class="flex flex-col w-full px-8 py-5">
      <div v-for="(social, index) in socialIcons" :key="index">
        <div class="text-grey-dark mb-2 font-bold">
          {{ $t('frontend_grooveblog_social_link') }} {{ index + 1 }}
        </div>
        <div class="flex mb-5">
          <div class="w-80 flex flex-col mr-5">
            <div class="flex items-center">
              <text-input v-model="social.social_link" :placeholder="$t('frontend_grooveblog_paste_link')" />
            </div>
          </div>
          <div class="w-80 flex flex-col icon-picker-wrapper">
            <button v-if="!social.show_picker" class="
                px-8
                h-10
                text-center
                w-auto
                heading-sm
                focus:outline-none
                shadow
                hover:shadow-lg
                focus:shadow-lg
                rounded-lg
                bg-white
                text-primary-dark
                focus:text-black
                border-primary-dark
                focus:border-black
                border border-solid
              " @click="social.show_picker = true">
              {{ $t('frontend_grooveblog_choose_icon') }}
            </button>
            <div v-if="social.show_picker">
              <font-awesome-picker v-model="social.social_icon"
                @change="fontPickerValue($event, index)"></font-awesome-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveSocial">Save</gd-button>
      </div>
    </div>
    <div v-if="generalTab === 'comment_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="flex flex-col mb-5">
        <div class="flex align-center">
          <label class="text-grey-dark mb-2">Facebook App Id </label>
          <a href="https://www.youtube.com/embed/-82mRgA_DSA" class="ml-3" target="_blank">
            <i class="fa fa-question-circle" aria-hidden="true"
              style="font-size: 22px; color: var(--brand-primary);"></i></a>
        </div>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input v-model="comment.app_id" class="w-2/3" placeholder="" :validator="$v.comment.app_id" />
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_width_pixel') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input v-model="comment.width" class="w-2/3" placeholder="" :validator="$v.comment.width" />
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_n_of_posts') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input v-model="comment.num_of_post" class="w-2/3" placeholder="" :validator="$v.comment.num_of_post" />
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveComment">{{ $t('frontend_save')
        }}</gd-button>
      </div>
    </div>
    <div v-if="generalTab === 'form_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_select_form') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <gd-dropdown :options="formList" class="w-full h-10 selectbox form-selectbox" v-model="selectedFormName"
              placeholder=""></gd-dropdown>
          </div>
        </div>
      </div>

      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_select_form_preset') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <gd-dropdown :options="formPresets" class="w-full h-10 selectbox form-selectbox" v-model="selectedFormPreset"
              placeholder=""></gd-dropdown>
          </div>
        </div>
      </div>

      <div v-if="formEditUrl" class="flex mb-5 text-grey-dark" v-html="$t(
        'frontend_grooveblog_edit_form_preset',
        {
          url: formEditUrl
        }
      )
        " />

      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveForm">{{ $t('frontend_save') }}</gd-button>
      </div>
    </div>
    <div v-if="generalTab === 'copyright_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="flex flex-col mb-5">
        <div class="flex w-full items-center mb-4">
          <label class="text-grey-dark pr-2">{{ $t('frontend_grooveblog_copy_text') }}</label>
          <gd-toggle v-model="showCopyrightToggle" />
        </div>
        <div class="flex items-center">
          <div class="flex flex-col w-80">
            <quill-editor v-if="showCopyrightToggle" ref="legalTextEditor" v-model="copyrightText"
              :options="copyrightEditorOptions" class="min-h-32 copyright-quill"
              @ready="onEditorReady($event)"></quill-editor>
            <div v-if="copyrightError" class="error text-red text-sm mt-2">
              {{ $t('frontend_grooveblog_settings_field_is_required') }}
            </div>
            <!-- <text-area
              v-model="copyrightText"
              class="h-20 form-textarea"
              placeholder=""
            /> -->
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveCopyright">{{ $t('frontend_save')
        }}</gd-button>
      </div>
    </div>
    <div v-if="generalTab === 'ads_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_header_ads_code') }}</label>
        <div class="flex items-center">
          <div class="w-80 h-20 form-textarea">
            <textarea class="
                w-full
                h-full
                outline-none
                px-4
                resize-none
                bg-white
                border border-solid
                rounded-lg
                text-grey-600
                border-grey-200
              " v-model="embedAds.header_ads">
            </textarea>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_footer_ads_code') }}</label>
        <div class="flex items-center">
          <div class="w-80 h-20 form-textarea">
            <textarea class="
                w-full
                h-full
                outline-none
                px-4
                resize-none
                bg-white
                border border-solid
                rounded-lg
                text-grey-600
                border-grey-200
              " v-model="embedAds.footer_ads">
            </textarea>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_sidebar_ads_code') }}</label>
        <div class="flex items-center">
          <div class="w-80 h-20 form-textarea">
            <textarea class="
                w-full
                h-full
                outline-none
                px-4
                resize-none
                bg-white
                border border-solid
                rounded-lg
                text-grey-600
                border-grey-200
              " v-model="embedAds.sidebar_ads">
            </textarea>
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveAds">{{ $t('frontend_save') }}</gd-button>
      </div>
    </div>
    <div v-if="generalTab === 'tracking_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_included_in') }} &lt;head&gt;</label>
        <div class="flex items-center">
          <div class="w-80 h-20 form-textarea">
            <textarea class="
                w-full
                h-full
                outline-none
                px-4
                resize-none
                bg-white
                border border-solid
                rounded-lg
                text-grey-600
                border-grey-200
              " v-model="trackingPixel.head">
            </textarea>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_included_in') }} &lt;body&gt; <span
            class="lowercase">{{ $t('frontend_top') }}</span> </label>
        <div class="flex items-center">
          <div class="w-80 h-20 form-textarea">
            <textarea class="
                w-full
                h-full
                outline-none
                px-4
                resize-none
                bg-white
                border border-solid
                rounded-lg
                text-grey-600
                border-grey-200
              " v-model="trackingPixel.body_top">
            </textarea>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_included_in') }} &lt;body&gt; <span
            class="lowercase">{{ $t('frontend_bottom') }}</span></label>
        <div class="flex items-center">
          <div class="w-80 h-20 form-textarea">
            <textarea class="
                w-full
                h-full
                outline-none
                px-4
                resize-none
                bg-white
                border border-solid
                rounded-lg
                text-grey-600
                border-grey-200
              " v-model="trackingPixel.body_bottom">
            </textarea>
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveTracking">{{ $t('frontend_save')
        }}</gd-button>
      </div>
    </div>

    <div v-if="generalTab === 'opengraph_setting'" class="flex flex-col w-full px-8 py-5">
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">Meta Title</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input v-model="metaData.title" class="w-2/3" placeholder="Enter Meta Title" />
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">Meta Description</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-area class="h-20 form-textarea" placeholder="Enter Meta description"
              v-model="metaData.description"></text-area>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">Meta Keywords</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-area class="h-20 form-textarea" placeholder="Enter Meta Keywords"
              v-model="metaData.keywords"></text-area>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_og_title') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input v-model="openGraph.title" class="w-2/3" placeholder="" />
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_og_url') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-input v-model="openGraph.url" class="w-2/3" placeholder="" />
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_og_type') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <!-- <text-input v-model="openGraph.type" class="w-2/3" placeholder="" /> -->
            <gd-dropdown :options="openGraphTypeList" class="w-full h-10 selectbox form-selectbox"
              v-model="openGraph.type" :placeholder="$t('frontend_grooveblog_select_open_graph_type')"></gd-dropdown>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_og_desc') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-area class="h-20 form-textarea" placeholder="" v-model="openGraph.description"></text-area>
          </div>
        </div>
      </div>
      <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">{{ $t('frontend_grooveblog_og_image') }}</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <image-picker v-model="openGraph.image" :primary="true"></image-picker>
          </div>
        </div>
      </div>
      <div class="flex flex-row">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveOpenGraph">{{ $t('frontend_save')
        }}</gd-button>
      </div>
    </div>

    <div
      v-if="generalTab === 'rss_setting'"
      class="flex flex-col w-full px-8 py-5"
    >
       <div class="flex flex-col mb-6">
          <label class="text-grey-dark mb-2">Author Name</label>
          <div class="flex items-center">
            <div class="w-80 mr-3">
              <text-input
                v-model="rssPayload.authorName"
                class="w-2/3"
                placeholder="Enter Author Name"
                :validator="$v.rssPayload.authorName"
                attribute="Author Name"
              />
            </div>
          </div>
        </div>
        <!-- <div class="flex flex-col mb-5">
        <label class="text-grey-dark mb-2">Author Bio</label>
        <div class="flex items-center">
          <div class="w-80 mr-3">
            <text-area
              class="h-20 form-textarea"
              placeholder="Enter Author Bio"
              v-model="rssPayload.authorBio"
            ></text-area>
          </div>
        </div>
      </div> -->
      <div class="domain-radio flex flex-col mb-1">
        <label class="text-grey-dark mb-2">Select Post Type</label>
        <div v-for="rssOption in rssType" :key="rssOption.id">
          <gd-custom-radio v-model="rssPayload.rssTypeValue" :option="rssOption"></gd-custom-radio>
        </div>
      </div>
      <div class="flex flex-col mb-5" v-if="rssPayload.rssTypeValue === 2">
        <div>
          <div class="text-dark pb-2">
            Select Posts
          </div>
          <div class="w-1/2">
            <treeselect dark v-model="rssPayload.selectedCategories" value-consists-of="LEAF_PRIORITY"
              placeholder="Select Post" :multiple="true" :options="allCategories" />
          </div>
        </div>
        <div class="w-full error text-primary-dark mt-1 text-sm"
          v-if="$v.rssPayload.selectedCategories.$invalid && $v.rssPayload.$dirty">
          Select Specific Posts.
        </div>
      </div>
      <div class="w-full mb-4 text-base flex" v-if="feedUrl">
        <label class="text-grey-dark mr-1">Feed URL : </label>
        <div class="text-grey-600">{{ feedUrl }}</div>
      </div>
      <div class="flex flex-row ">
        <gd-button size="auto" class="px-8 h-10" variant="primary" @click="saveRss">{{ $t('frontend_save') }}</gd-button>
      </div>
    </div>


    <gd-banner v-if="showSaveMessage || showCommentMessage"
    :text=" showCommentMessage ? $t('frontend_grooveblog_domain_settings_save') : $t('frontend_grooveblog_settings_save') "
    variant="success" :showIcon="true"
      position="bottom-right" />

  </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
import { required, requiredIf } from 'vuelidate/lib/validators';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ImagePicker from '@groovepages/gd-ui-kit/components/ImagePickerModal';
import axios from 'axios';
import DomainDropdown from '@groovepages/gd-ui-kit/components/DomainDropdown';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import themeConfig from '@/theme/themeConfig.js';
import FontAwesomePicker from './FontAwesomePicker.vue';

export default {
  metaInfo() {
    return { title: 'Settings' };
  },
  components: { Loading, ImagePicker, FontAwesomePicker, DomainDropdown, Treeselect, quillEditor, },
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      blogId: '',
      tag: [],
      setUrl: {
        blog_id: '',
        seo_blogpost: '',
        seo_tag: '',
        seo_categories: '',
        preferred_url: 'nonwww',
      },
      generalTabs: [
        { title: 'SEO', value: 'seo_setting' },
        { title: this.$t('frontend_grooveblog_general_tab_domains'), value: 'domain_setting' },
        { title: 'Logo', value: 'logo_setting' },
        { title: 'Favicon', value: 'favicon_setting' },
        { title: this.$t('frontend_grooveblog_general_tab_social_links'), value: 'social_setting' },
        { title: this.$t('frontend_grooveblog_general_tab_comments'), value: 'comment_setting' },
        { title: 'Forms', value: 'form_setting' },
        { title: 'Copyright', value: 'copyright_setting' },
        { title: 'Embed Ads', value: 'ads_setting' },
        { title: this.$t('frontend_grooveblog_general_tab_tracking_pixels'), value: 'tracking_setting' },
        { title: 'OG & Meta Settings', value: 'opengraph_setting' },
        { title: 'RSS Setting', value: 'rss_setting' },
      ],
      generalTab: 'seo_setting',
      data_variable: true,
      publishTypeList: [
        { id: 1, title: this.$t('frontend_grooveblog_publish_type_title_1') },
        { id: 2, title: this.$t('frontend_grooveblog_publish_type_title_2') }
      ],
      setBlogSite: {
        blog_id: '',
        sub_domain: '',
        custom_domains: '',
        publish_type: '',
        folder_name: '',
        publish_folder: '',
      },
      blog: {},
      logoImage:
        'https://assets.grooveapps.com/images/5f0d5c882a049a001c814670/thumbnails/1611765371_logo.png',
      faviconImage:
        'https://assets.grooveapps.com/images/5f0d5c882a049a001c814670/1612550721_favicon.png',
      comment: {
        app_id: '',
        width: '',
        num_of_post: '',
      },
      forms: '',
      formList: [],
      formPresets: [],
      formDetails: {
        form_name: '',
        form_id: '',
        preset_id: '',
      },
      showCopyrightToggle: false,
      copyrightError: false,
      copyrightText: this.$t('frontend_grooveblog_default_copy_text'),
      copyrightEditorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['link'],
          ],
        },
        theme: 'snow',

      },
      selectedFormName: '',
      selectedFormPreset: '',
      formparmaLink: '',
      showSaveMessage: false,
      showCommentMessage: false,
      embedAds: {
        header_ads: '',
        footer_ads: '',
        sidebar_ads: '',
      },
      trackingPixel: {
        head: '',
        body_top: '',
        body_bottom: '',
      },
      socialIcons: [
        {
          social_link: '',
          social_icon: 'far fa-question-circle',
          show_picker: false,
        },
        {
          social_link: '',
          social_icon: 'far fa-question-circle',
          show_picker: false,
        },
        {
          social_link: '',
          social_icon: 'far fa-question-circle',
          show_picker: false,
        },
        {
          social_link: '',
          social_icon: 'far fa-question-circle',
          show_picker: false,
        },
        {
          social_link: '',
          social_icon: 'far fa-question-circle',
          show_picker: false,
        },
      ],
      subDomainValue: '',
      subDomainMessage: false,
      customDomainValue: true,
      customDomainMessage: false,
      domainType: [
        {
          id: 1,
          title: this.$t('frontend_grooveblog_domain_type_title_1'),
        },
        {
          id: 2,
          title: this.$t('frontend_grooveblog_domain_type_title_2'),
        },
        {
          id: 3,
          title: this.$t('frontend_grooveblog_domain_type_title_3'),
        },
      ],
      domainTypeValue: 1,
      preferredRootDomainUrlOptions: [
                {
          id: 'nonwww',
          title: this.$t('frontend_preferred_url_non_www'),
        },
        {
          id: 'www',
          title: this.$t('frontend_preferred_url_www'),
        },
      ],
      folderAvailable: true,
      domainAvailable: true,
      openGraphTypeList: ['blog', 'article', 'author', 'book', 'game', 'movie', 'food', 'recipe', 'company', 'hotel', 'restaurant'],
      openGraph: {
        title: '',
        url: '',
        type: '',
        description: '',
        image: '',
      },
      metaData: {
        title: '',
        description: '',
        keywords: '',
      },
      tagError: false,
      postnameToken: true,
      feedUrl: null,
      rssType: [
        {
          id: 3,
          title: this.$t('frontend_grooveblog_general_all_posts'),
        },
        {
          id: 1,
          title: this.$t('frontend_grooveblog_general_popular_posts'),
        },
        {
          id: 2,
          title: this.$t('frontend_grooveblog_general_specific_posts'),
        },
      ],

      allCategories: [
        {
          id: 'allcategories',
          label: 'All Categories',
          children: [],
        },
      ],
      rssPayload: {
        authorName: '',
        rssTypeValue: 3,
        selectedCategories: [],
        postList: [],
      },
      captureScreenshot: {
        form: false,
        social_icons: false,
        embed_ads: false
      },
    };
  },
  validations: {
    setUrl: {
      seo_blogpost: {
        required,
        fieldIsRequired(seo_blogpost) {
          if (seo_blogpost === "/") {
            return false;
          }
          return true;
        }
      },
      seo_tag: {
        required,
        fieldIsRequired(seo_tag) {
          if (seo_tag === "/") {
            return false;
          }
          return true;
        }
      },
      seo_categories: {
        required,
        fieldIsRequired(seo_categories) {
          if (seo_categories === "/") {
            return false;
          }
          return true;
        }
      },
    },
    setBlogSite: {
      sub_domain: {
        required,
      },
    },
    comment: {
      app_id: {
        required,
      },
      width: {
        required,
      },
      num_of_post: {
        required,
      },
    },
    rssPayload: {
      authorName: {
        required,
      },
      rssTypeValue: {
        required
      },
      selectedCategories: {
        required: requiredIf((rssPayload) => {
          if (rssPayload.rssTypeValue === 2) {
            return true;
          }
          return false;
        }),
      }
    }
  },
  mounted() {
    this.blogId = localStorage.getItem('blog-id');
    this.setUrl.blog_id = this.blogId;
    this.setBlogSite.blog_id = this.blogId;
    this.getBlogSite();
    this.getUrl();
    this.getBlogData();
    this.getFormData();
    // this.availableDomains();
    if (this.$route.query.type === 'domain_setting') {
      this.generalTab = 'domain_setting';
    } else {
      this.generalTab = 'seo_setting';
    }
    this.getCategories();

  },
  watch: {
    socialIcons: {
      handler() {
        this.setScreenshot('social_icons');
      },
      deep: true
    },
    embedAds: {
      handler() {
        this.setScreenshot('embed_ads');
      },
      deep: true
    },
    selectedFormName() {
      this.setScreenshot('form');
    },
    selectedFormPreset() {
      this.setScreenshot('form');
    },
  },

  computed: {
    grooveblogDomain() {
      return window.gdEnv['VUE_APP_GROOVEBLOG_URL'].match(/\/\/(.+)$/)[1] || 'grooveblog.com'
    },
    formEditUrl() {
      if (this.selectedFormPreset && this.selectedFormName) {

        const selectedForm = this.forms.find(
          (form) => form.name === this.selectedFormName
        );

        if (selectedForm && selectedForm.id) {
          return `${window.config.grooveappsurl}/groovemail/form/edit/${selectedForm.id}?step=design&preset=${this.selectedFormPreset}`;
        }
      }
      return null;
    },
  },
  methods: {
    setScreenshot(field) {
      if (this.captureScreenshot && !this.captureScreenshot[field]) {
        this.captureScreenshot[field] = true;
      }
    },
    getUrl() {
      this.showLoader();
      axios
        .get(`/settings/${this.blogId}`)
        .then((response) => {
          this.setUrl = response.data.data;
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveUrl() {
      this.$v.setUrl.$touch();
      console.log(this.$v.setUrl.$invalid);
      if (!this.$v.setUrl.$invalid) {
        this.$v.setUrl.$reset();
        this.showLoader();

        let seoBlogPostText = this.setUrl.seo_blogpost.split("/",1);
        let temp = seoBlogPostText;
        console.log(seoBlogPostText);
        seoBlogPostText = seoBlogPostText[0].replace(/[^A-Z0-9/_]+/gi, '-')
          .toLowerCase()
          .replace(/^-+/, "") // trim - from start of text
          .replace(/-+$/, ""); // trim - from end of text
        this.setUrl.seo_blogpost = this.setUrl.seo_blogpost.replace(temp, seoBlogPostText);

        let seoTagText = this.setUrl.seo_tag.split("/", 1);
        temp = seoTagText;
        seoTagText = seoTagText[0].replace(/[^A-Z0-9/_]+/gi, '-')
          .toLowerCase()
          .replace(/^-+/, "") // trim - from start of text
          .replace(/-+$/, ""); // trim - from end of text;
        this.setUrl.seo_tag = this.setUrl.seo_tag.replace(temp, seoTagText);
        let seoCategoriesText = this.setUrl.seo_categories.split("/", 1);
        temp = seoCategoriesText;
        seoCategoriesText = seoCategoriesText[0].replace(/[^A-Z0-9/_]+/gi, '-')
          .toLowerCase()
          .replace(/^-+/, "") // trim - from start of text
          .replace(/-+$/, ""); // trim - from end of text
        this.setUrl.seo_categories = this.setUrl.seo_categories.replace(temp, seoCategoriesText);
        // seoBlogPostText = seoBlogPostText
        //   .replace(/[^A-Z0-9/_]+/gi, '-')
        //   .toLowerCase();
        // this.setUrl.seo_tag = this.setUrl.seo_tag
        //   .replace(/[^A-Z0-9/_]+/gi, '-')
        //   .toLowerCase();
        // this.setUrl.seo_categories = this.setUrl.seo_categories
        //   .replace(/[^A-Z0-9/_]+/gi, '-')
        //   .toLowerCase();
        axios
          .post('/settings', this.setUrl)
          .then(() => {
            this.hideLoader();
            this.saveSetting();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getBlogSite() {
      this.showLoader();
      axios
        .get(`/site/${this.blogId}`)
        .then((response) => {
          this.setBlogSite = response.data.data;
          if (
            this.setBlogSite.publish_custom_domain === 0 &&
            this.setBlogSite.publish_sub_domain === 1
          ) {
            this.domainTypeValue = 1;
          } else if (this.setBlogSite.publish_folder === 1) {
            this.domainTypeValue = 3;
          } else {
            this.domainTypeValue = 2;
          }
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async saveBlogSite() {
      this.$v.setBlogSite.$touch();
      if (!this.$v.setBlogSite.$invalid) {
        this.$v.setBlogSite.$reset();
        this.showLoader();
        this.setBlogSite.publish_type = 1;
        await axios
          .get(
            `/blogs/check-subdomain/${this.setBlogSite.sub_domain}?blog_id=${this.blogId}`
          )
          .then((response) => {
            this.subDomainValue = response.data.available;
          })
          .catch((error) => {
            console.log(error);
          });
        if (this.setBlogSite.custom_domains && (!this.$store.getters.canUseNewFeature || this.domainTypeValue === 2)) {
          await axios
            .get(
              `/blogs/check-domain/${this.setBlogSite.custom_domains}?blog_id=${this.blogId}`
            )
            .then((response) => {
              this.customDomainValue = response.data.available;
            })
            .catch((error) => {
              console.log(error);
            });
        }
        if (this.subDomainValue && (this.customDomainValue || (this.$store.getters.canUseNewFeature && this.domainTypeValue === 3))) {
          this.subDomainMessage = false;
          this.customDomainMessage = false;
          if (this.domainTypeValue === 3) {
            if (this.setBlogSite.folder_name) {
              await axios
                .get(
                  `/blogs/check-folder/${this.blogId}/${this.setBlogSite.custom_domains}/${this.setBlogSite.folder_name}`
                )
                .then((response) => {
                  this.folderAvailable = response.data.folder_available;
                  this.domainAvailable = response.data.domain_available;
                  if (this.folderAvailable && this.domainAvailable) {
                    axios
                      .post('/site', this.setBlogSite)
                      .then((result) => {
                        this.hideLoader();
                        this.saveCommentSetting();
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              this.folderAvailable = false;
            }
          } else {
            axios
              .post('/site', this.setBlogSite)
              .then((result) => {
                this.hideLoader();
                this.saveCommentSetting();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        } else if (!this.subDomainValue) {
          this.customDomainMessage = false;
          this.subDomainMessage = true;
        } else if (!this.customDomainValue) {
          this.subDomainMessage = false;
          this.customDomainMessage = true;
        } else {
          this.subDomainMessage = true;
          this.customdomainMessage = true;
        }
        this.hideLoader();
      }
    },
    touchInput() {
      this.$v.setBlogSite.$touch();
    },
    generalTabChange(newTab) {
      this.generalTab = newTab;
      if (newTab === 'social_setting') {
        console.log('Its social tab');
      }
    },
    getBlogData() {
      this.showLoader();
      axios
        .get(`/blogs/${this.blogId}`)
        .then((response) => {
          this.blog = response.data.data;
          console.log(this.blog.rss_settings, '---rss settings');
          if (this.blog.logo !== null) {
            this.logoImage = this.blog.logo;
          }
          if (this.blog.favicon !== null) {
            this.faviconImage = this.blog.favicon;
          }
          if (this.blog.facebook_comment_settings !== null) {
            this.comment = this.blog.facebook_comment_settings;
          }
          if (this.blog.social_icons !== null) {
            this.socialIcons = this.blog.social_icons;
          }
          if (this.blog.form_details !== null) {
            this.formDetails = this.blog.form_details;
            this.selectedFormName = this.formDetails.form_name;
            this.selectedFormPreset = this.formDetails.preset_id ?? '';
          }
          if (this.blog.copyright !== null) {
            this.copyrightText = this.blog.copyright;
          }
          this.showCopyrightToggle = this.blog.show_copyright;
          if (this.blog.embed_ads !== null) {
            this.embedAds = this.blog.embed_ads;
          }
          if (this.blog.tracking_ga !== null) {
            this.trackingPixel = this.blog.tracking_ga;
          }
          if (this.blog.open_graph !== null) {

            this.openGraph = this.blog.open_graph;
          }
          if (this.blog.meta_data !== null) {

            this.metaData = this.blog.meta_data;
          }
          if (this.blog.open_graph === null || this.blog.open_graph.url === null) {
            this.openGraph.url = this.blog.published_url;
          }
          if (this.blog.open_graph && this.blog.open_graph.type !== null) {
            const result = this.openGraphTypeList.includes(this.blog.open_graph.type);
            if (!result) {
              this.openGraphTypeList.push(this.blog.open_graph.type);
            }
          }
          if (this.blog.rss_settings !== null) {
            this.rssPayload = this.blog.rss_settings;
            this.feedUrl = `${this.blog.published_url}/feed.xml`; // Setting rss feed URL
          }

          this.$nextTick(() => {
            for (const key in this.captureScreenshot) {
              this.captureScreenshot[key] = false;
            }
          });
          this.hideLoader();
        })
        .catch((error) => {
          console.log('----error---', error);
        });

    },
    saveLogo() {
      this.showLoader();
      axios
        .put(`/blogs/${this.blogId}`, {
          logo: this.logoImage,
          take_screenshot: this.logoImage !== this.blog.logo,
        })
        .then((response) => {
          this.hideLoader();
          this.blog.logo = this.logoImage;
          this.saveSetting();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveFavicon() {
      this.showLoader();
      axios
        .put(`/blogs/${this.blogId}`, {
          favicon: this.faviconImage,
          take_screenshot: this.faviconImage !== this.blog.favicon,
        })
        .then((response) => {
          this.hideLoader();
          this.blog.favicon = this.faviconImage;
          this.saveSetting();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveSocial() {
      this.showLoader();
      const takeScreenshot = this.captureScreenshot.social_icons;
      for (const i in this.socialIcons) {
        this.$set(this.socialIcons[i], 'show_picker', false);
      }
      axios
        .put(`/blogs/${this.blogId}`, {
          social_icons: this.socialIcons,
          take_screenshot: takeScreenshot,
        })
        .then((response) => {
          this.hideLoader();
          this.captureScreenshot.social_icons = false;
          this.saveSetting();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveComment() {
      this.$v.comment.$touch();
      if (!this.$v.comment.$invalid) {
        this.$v.comment.$reset();
        this.showLoader();
        axios
          .put(`/blogs/${this.blogId}`, {
            facebook_comment_settings: this.comment,
          })
          .then(() => {
            this.hideLoader();
            this.saveSetting();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    saveForm() {
      this.getFormId();
      this.formDetails.form_id = this.formparmaLink;
      this.formDetails.form_name = this.selectedFormName;
      this.formDetails.preset_id = this.selectedFormPreset;
      if (this.formDetails.form_id) {
        this.showLoader();
        axios
          .put(`/blogs/${this.blogId}`, {
            form_details: this.formDetails,
            take_screenshot: this.captureScreenshot.form,
          })
          .then(() => {
            this.hideLoader();
            this.captureScreenshot.form = false;
            this.saveSetting();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    saveCopyright() {
      this.showLoader();
      const text = this.showCopyrightToggle
        ? this.copyrightText.replaceAll(/<[/]?(?!(a)|(strong)|(em)|(u)|(s))[\w]+>/g, ' ')
          .replace(/\s{2,}/g, ' ')
          .trim()
        : null;

      if (this.showCopyrightToggle && text.length < 1) {
        this.copyrightError = true;
        this.hideLoader();
        return;
      }
      this.copyrightError = false;

      axios
        .put(`/blogs/${this.blogId}`, {
          copyright: text,
          show_copyright: this.showCopyrightToggle,
          take_screenshot: this.copyrightText !== this.blog.copyright,
        })
        .then(() => {
          this.hideLoader();
          this.blog.copyright = this.copyrightText;
          this.saveSetting();
        })
        .catch((error) => {
          this.hideLoader();
          console.log(error);
        });
    },
    onEditorReady(quill) {
      // Get last child of toolbar
      const toolbar = document.getElementsByClassName('ql-toolbar').item(0).lastChild;

      if (toolbar) {
        // Create year element
        const year = document.createElement('button');
        year.classList.add('ql-year');
        year.setAttribute('type', 'button');
        year.innerHTML = `<svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 5V1M14 5V1M5 9H15M3 19H17C18.1046 19 19 18.1046 19 17V5C19 3.89543 18.1046 3 17 3H3C1.89543 3 1 3.89543 1 5V17C1 18.1046 1.89543 19 3 19Z" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

        // Append year element in last child of toolbar
        toolbar.appendChild(year);

        // Add event listener to perform action when clicked
        year.addEventListener('click', () => {
          const selection = quill.getSelection(true);
          quill.insertText(
            selection.index,
            '{year}'
          );
        });
      }
    },
    saveSetting() {
      this.showSaveMessage = true;
      setTimeout(() => {
        this.showSaveMessage = false;
      }, 2000);
    },
    saveCommentSetting() {
      this.showCommentMessage = true;
      setTimeout(() => {
        this.showCommentMessage = false;
      }, 10000);
    },
    getFormData() {
      const groovemailUrl = window.config.apiUrl.substr(
        0,
        window.config.apiUrl.lastIndexOf('/')
      );
      this.showLoader();
      axios
        .get(`${groovemailUrl}/groovemail/mailform`)
        .then((response) => {
          this.forms = response.data;
          for (let i = 0; i < this.forms.length; i++) {
            if (this.forms[i].lists !== '[]') {
              this.formList.push(this.forms[i].name);
            }
          }
          if (!this.selectedFormName && this.formList.length) {
            this.selectedFormName = this.formList[0];
          }
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });

      axios
        .get(`${groovemailUrl}/groovemail/mailformstyle`)
        .then((response) => {
          this.formPresets = response.data.map((preset) => {
            return {
              text: preset.name,
              value: preset.id,
            };
          });

          if (!this.selectedFormPreset && this.formList.length) {
            this.selectedFormPreset = this.formPresets[0].value;
          }

        })
        .catch((error) => {
          console.error(error);
        });
    },
    getFormId() {
      const selectedForm = this.forms.find(
        (form) => form.name === this.selectedFormName
      );
      if (selectedForm && selectedForm.id) {
        this.formparmaLink = window.btoa(selectedForm.id);
      }
    },
    saveAds() {
      this.showLoader();
      axios
        .put(`/blogs/${this.blogId}`, {
          embed_ads: this.embedAds,
          take_screenshot: this.captureScreenshot.embed_ads
        })
        .then(() => {
          this.hideLoader();
          this.captureScreenshot.embed_ads = false;
          this.saveSetting();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveTracking() {
      this.showLoader();
      axios
        .put(`/blogs/${this.blogId}`, {
          tracking_ga: this.trackingPixel,
        })
        .then(() => {
          this.hideLoader();
          this.saveSetting();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fontPickerValue(e, i) {
      this.socialIcons[i].social_icon = e;
    },
    availableDomains() {
      const availableDomains =
        this.$store.getters.user.metadata.domainsList || {};
      return Object.keys(availableDomains).filter(
        (domain) => availableDomains[domain].platform === 'blog'
      );
    },
    editDomains() {
      this.$root.$emit('open-account-modal', 'Domains');
    },
    domainTypeChange() {
      if (this.domainTypeValue === 2) {
        this.setBlogSite.publish_folder = 0;
      } else if (this.domainTypeValue === 3) {
        this.setBlogSite.publish_folder = 1;
        this.setBlogSite.publish_custom_domain = 1;
      } else {
        this.setBlogSite.publish_folder = 0;
        this.setBlogSite.publish_custom_domain = 0;
        this.setBlogSite.publish_sub_domain = 1;
      }
      this.setBlogSite.custom_domains = '';
    },
    saveOpenGraph() {
      this.showLoader();
      axios
        .put(`/blogs/${this.blogId}`, {
          open_graph: this.openGraph,
          meta_data: this.metaData,
        })
        .then(() => {
          this.hideLoader();
          this.saveSetting();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    postTokenEnter(value) {
      console.log(value);
      if (value === "%postname%/" || value === "%slug%/") this.postnameToken = false;
      if (this.setUrl.seo_blogpost.search(value) > -1) {
        this.setUrl.seo_blogpost = this.setUrl.seo_blogpost.replace(value, '');
        if (this.setUrl.seo_blogpost.search("%slug%/") <= -1 && this.setUrl.seo_blogpost.search("%postname%/") <= -1) this.postnameToken = true;
        return;
      }

      const textarea = this.$refs.postarea.$refs.input;
      const sentence = textarea.value;
      const len = sentence.length;
      let pos = textarea.selectionStart;
      if (pos === undefined) {
        pos = 0;
      }

      const before = sentence.substr(0, pos);
      const after = sentence.substr(pos, len);


      if (pos === 0 || this.setUrl.seo_blogpost.charAt(this.setUrl.seo_blogpost.length - 1) !== "/") {
        const finalvalue = `/${value}`;
        value = finalvalue;
      }

      if (value === '%category%/') {
        this.showLoader();
        axios
          .get(`/seo-category-validate/${this.blogId}/1`)
          .then((response) => {
            if (response.data.available) {
              this.setUrl.seo_blogpost = before + value + after;
            } else {
              this.tagError = true;
              console.log("Its false");
            }
            this.hideLoader();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {

        this.tagError = false;
        this.setUrl.seo_blogpost = before + value + after;
      }


      this.$nextTick().then(() => {
        textarea.selectionStart = pos + value.length;
      });

    },
    tagTokenEnter(value) {
      console.log(value);
      console.log('value', this.setUrl.seo_tag);
      console.log(this.setUrl.seo_tag.search(value));
      if (this.setUrl.seo_tag.search(value) > -1) {
        this.setUrl.seo_tag = this.setUrl.seo_tag.replace(value, '');
        return;
      }
      console.log(`${this.disabled}---${value}`);
      const textarea = this.$refs.tagarea.$refs.input;
      const sentence = textarea.value;
      const len = sentence.length;
      let pos = textarea.selectionStart;
      if (pos === undefined) {
        pos = 0;
      }

      const before = sentence.substr(0, pos);
      const after = sentence.substr(pos, len);
      console.log(len);
      this.disabled = !this.disabled;
      if (pos === 0 || this.setUrl.seo_tag.charAt(this.setUrl.seo_tag.length - 1) !== "/") {
        const finalvalue = `/${value}`;
        value = finalvalue;
      }


      this.setUrl.seo_tag = before + value + after;



      this.$nextTick().then(() => {
        textarea.selectionStart = pos + value.length;
      });
    },
    categoryTokenEnter(value) {
      console.log(value);
      console.log('value', this.setUrl.seo_categories);
      console.log(this.setUrl.seo_categories.search(value));
      if (this.setUrl.seo_categories.search(value) > -1) {
        this.setUrl.seo_categories = this.setUrl.seo_categories.replace(value, '');
        return;
      }
      console.log(`${this.disabled}---${value}`);
      const textarea = this.$refs.categoryarea.$refs.input;
      const sentence = textarea.value;
      const len = sentence.length;
      let pos = textarea.selectionStart;
      if (pos === undefined) {
        pos = 0;
      }

      const before = sentence.substr(0, pos);
      const after = sentence.substr(pos, len);
      console.log(len);
      this.disabled = !this.disabled;
      if (pos === 0 || this.setUrl.seo_categories.charAt(this.setUrl.seo_categories.length - 1) !== "/") {
        const finalvalue = `/${value}`;
        value = finalvalue;
      }


      this.setUrl.seo_categories = before + value + after;



      this.$nextTick().then(() => {
        textarea.selectionStart = pos + value.length;
      });
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
    saveRss() {
      this.$v.rssPayload.$touch();
      if (!this.$v.rssPayload.$invalid) {
        this.$v.rssPayload.$reset();
        this.showLoader();
        if (this.rssPayload.rssTypeValue !== 2) {
          this.rssPayload.selectedCategories = [];
        }

        axios
        .put(`/blogs/${this.blogId}`, {
          rss_settings: this.rssPayload,
        })
        .then((response) => {
          this.hideLoader();
          if(!this.feedUrl && this.blog.published_url) {
            this.feedUrl = `${this.blog.published_url}/feed.xml`;
          }
          this.saveSetting();
        })
        .catch((error) => {
          console.log(error);
        });

      }
    },
    async getCategories() {
      await axios
        .get(`/categories_post?blog_id=${this.blogId}`)
        .then((response) => {
          const categoriesRes = response.data.data;
          this.allCategories[0].children = categoriesRes;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.general-radio .border.p-2 {
  border: none;
  padding: 0;
}

.general-radio .w-6 {
  height: 22px;
  margin: 0;
}

.form-selectbox .h-8 {
  height: 40px;
}

.form-selectbox svg {
  top: 4px;
}

.form-selectbox .italic.select-none {
  display: none;
}

.form-selectbox.select-domain .italic.select-none {
  display: block;
}

.form-textarea textarea {
  padding: 10px 16px;
}

.icon-picker-wrapper .fontawesome-picker__picker {
  position: absolute;
  left: 0;
  top: 40px;
  z-index: 9;
  background-color: #292b49;
}

.domain-radio .border.p-2 {
  border: none;
  padding: 0;
}

.domain-radio .w-6 {
  height: 22px;
  margin: 0;
}
.domain-radio.domain-radio-small .w-6 {
  height: 20px;
  margin: 0;
}

.domain-radio .font-semibold {
  font-weight: normal;
  color: #000;
  line-height: 22px;
  margin-left: 4px;
}

.available-tags {
  border-radius: 4px;
}

.available-tags.active {
  background-color: #ccc;
}

.copyright-quill .ql-toolbar {
  border-radius: 0px;
  box-shadow: none;
  background: none;
  display: block;
  padding: 0px 0px 0px 7px;
}

.copyright-quill .ql-picker {
  height: auto;
}

.copyright-quill .ql-editor.ql-blank:before {
  font-style: italic;
  left: 15px;
}

.copyright-quill .ql-container {
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
}

.copyright-quill {
  font-size: 16px;
  padding: 0px;
}

.copyright-quill .ql-editor {
  padding: 12px 15px;
  line-height: normal;
}

.copyright-quill .ql-tooltip.ql-editing {
  left: 0px !important;
}
</style>
